import React, { useContext, useState } from 'react';
import { ButtonDropdown, ButtonDropdownProps } from '@amzn/awsui-components-core';

import arraySort from 'array-sort';
import CommunityCollectionCtx from './CommunityCollectionCtx';

enum CollectionSortOption {
  NewToOld = 'Sort by newest to oldest date',
  OldToNew = 'Sort by oldest to newest date',
  AToZ = 'Sort by title A to Z',
  ZToA = 'Sort by title Z to A',
}

const CollectionSortDropDown = () => {
  const { setFilteredCollections, filteredCollections } = useContext(CommunityCollectionCtx);

  const [selectedSortId, setSelectedSortId] = useState<CollectionSortOption>(
    CollectionSortOption.NewToOld,
  );
  const dropDownItems = [
    { text: CollectionSortOption.NewToOld, id: CollectionSortOption.NewToOld },
    { text: CollectionSortOption.OldToNew, id: CollectionSortOption.OldToNew },
    { text: CollectionSortOption.AToZ, id: CollectionSortOption.AToZ },
    { text: CollectionSortOption.ZToA, id: CollectionSortOption.ZToA },
  ];

  const handleSortClick = (event: CustomEvent<ButtonDropdownProps.ItemClickDetails>) => {
    const eventId = event.detail.id as CollectionSortOption;
    switch (eventId) {
      case CollectionSortOption.NewToOld:
        arraySort(filteredCollections, 'createdAt', { reverse: true });
        break;
      case CollectionSortOption.OldToNew:
        arraySort(filteredCollections, 'createdAt');
        break;
      case CollectionSortOption.AToZ:
        arraySort(filteredCollections, 'title');
        break;
      case CollectionSortOption.ZToA:
        arraySort(filteredCollections, 'title', { reverse: true });
        break;
    }
    setFilteredCollections([...filteredCollections]);
    setSelectedSortId(eventId);
  };

  return (
    <ButtonDropdown onItemClick={handleSortClick} items={dropDownItems}>
      {selectedSortId}
    </ButtonDropdown>
  );
};

export default CollectionSortDropDown;
